import { line, curveLinear } from 'd3-shape';

/**
 * Render Skysight's blue wind-speed curve along the right side of the chart.
 *
 * Source: Skysight bundle (`this.windLines`). Position formula:
 *   x(slice) = tMax - (tMax - tMin) / 5 + slice.wspd / tMult
 *   y(slice) = scales.y(slice.press)
 *   tMult     = (max wspd in data) / ((tMax - tMin) / 5)
 *
 * The curve sits in the right ~1/5 of the chart's temperature range, so it
 * doesn't visually compete with the temp/dewpoint curves on the left.
 *
 * @param {import('d3-selection').Selection} container - lib's <g id="container">
 * @param {import('../skewt/scales.js').Scales} scales
 * @param {Array<{press, wspd}>} data - sounding payload
 */
export function drawWindLine(container, scales, data) {
    container.selectAll('.skewt-ext-wind-line').remove();
    if (!data || data.length === 0) return;

    const valid = data.filter((d) => Number.isFinite(d.wspd) && Number.isFinite(d.press));
    if (valid.length < 2) return;

    const tMax = scales.tMax;
    const tMin = scales.tMin;
    const range = (tMax - tMin) / 5;        // wind-line spans rightmost 1/5 of temp axis
    const maxWspd = Math.max(...valid.map((d) => d.wspd));
    // Skysight rounds UP to the next multiple of 5 so the rightmost tick
    // (e.g. "15") lands exactly at the chart's right edge — not past it.
    // Source: const t = Math.ceil(maxWspd / 5) * 5; tMult = t / range;
    const scaleMax = Math.max(5, Math.ceil(maxWspd / 5) * 5);
    const tMult = scaleMax / range;

    const xOfWspd = (wspd) => tMax - range + wspd / tMult;
    const pathGen = line()
        .x((d) => scales.x(xOfWspd(d.wspd)))
        .y((d) => scales.y(d.press))
        .curve(curveLinear);

    container.append('path')
        .attr('class', 'skewt-ext-wind-line')
        .attr('d', pathGen(valid))
        .attr('fill', 'none')
        .attr('stroke', '#1e3a8a')   // deep blue, matches Skysight `.wind`
        .attr('stroke-width', 1.5)
        .attr('pointer-events', 'none');
}
